import React from 'react';

// Components
import LunchBreakOptions from 'scenes/Time/components/LunchBreakOptions';
// @ts-ignore
import TableCellRenderDropdown from '../TableCellRenderDropdown';

export class LunchBreakTableCellRenderDropdown extends React.PureComponent {
    render(): React.ReactElement {
        return (
            <LunchBreakOptions>
                <TableCellRenderDropdown {...this.props} />
            </LunchBreakOptions>
        );
    }
}

export default LunchBreakTableCellRenderDropdown;
